export default __webpack_public_path__ + "static/media/Ballroll_00284.6c910589.png";